/**
 * Parses table data from a template response
 * Handles both string and already-parsed JSON formats
 * @param {string|Array} tableString - Table data as JSON string or array
 * @returns {Array} Parsed table data array, or empty array on error
 */
export const parseTableData = (tableString) => {
    if (!tableString) return [];
    try {
        let parsed = typeof tableString === "string" ? JSON.parse(tableString) : tableString;
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
        }

        if (Array.isArray(parsed)) {
            return parsed;
        } else if (parsed && parsed.rows && Array.isArray(parsed.rows)) {
            return parsed.rows;
        } else if (parsed && parsed.tables && parsed.tables.rows && Array.isArray(parsed.tables.rows)) {
            return parsed.tables.rows;
        }
        return [];
    } catch (err) {
        console.warn("Failed to parse template table data:", err);
        return [];
    }
};

/**
 * Parses relevant names from a template response
 * Handles both string and already-parsed JSON formats
 * @param {string|Array} relevantNamesString - Relevant names as JSON string or array
 * @returns {Array} Parsed relevant names array, or empty array on error
 */
export const parseRelevantNames = (relevantNamesString) => {
    if (!relevantNamesString) return [];
    try {
        let parsed = typeof relevantNamesString === "string" ? JSON.parse(relevantNamesString) : relevantNamesString;
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
        }

        if (!Array.isArray(parsed)) return [];
        return parsed
            .map(item => (typeof item === 'string' ? item : item?.name))
            .filter(name => !!name);
    } catch (err) {
        console.warn("Failed to parse relevant names:", err);
        return [];
    }
};

